import { api } from 'redux-store/api';

import {
  ICompletePhaseItemBody,
  ICreatePhaseItemBody,
  ICreatePhaseItemResponse,
  IDeletePhaseItemBody,
  IIncompletePhaseItemBody,
  IUpdatePhaseItemBody,
  IUpdatePhaseItemResponse,
} from './';

enum Endpoints {
  SCHEDULE_PHASE_ITEMS = 'project-schedule/phase-items/',
}

export const schedulePhasesItemsApi = api.injectEndpoints({
  endpoints: (build) => ({
    createSchedulePhaseItem: build.mutation<ICreatePhaseItemResponse, ICreatePhaseItemBody>({
      query: ({ projectId, withoutRefetching, ...data }) => ({
        url: Endpoints.SCHEDULE_PHASE_ITEMS,
        body: data,
        method: 'POST',
      }),
      invalidatesTags: (result, _, args) =>
        result && !args?.withoutRefetching ? [{ type: 'Projects', id: args.projectId }] : [],
    }),

    updateSchedulePhaseItem: build.mutation<IUpdatePhaseItemResponse, IUpdatePhaseItemBody>({
      query: ({ id, projectId, withoutRefetching, ...data }) => ({
        url: `${Endpoints.SCHEDULE_PHASE_ITEMS}${id}`,
        body: data,
        method: 'PATCH',
      }),
      invalidatesTags: (result, _, args) =>
        result && !args?.withoutRefetching ? [{ type: 'Projects', id: args.projectId }] : [],
    }),

    completeSchedulePhaseItem: build.mutation<IUpdatePhaseItemResponse, ICompletePhaseItemBody>({
      query: ({ id, ...data }) => ({
        url: `${Endpoints.SCHEDULE_PHASE_ITEMS}complete/${id}`,
        body: data,
        method: 'PATCH',
      }),
      invalidatesTags: ['Projects'],
    }),

    incompleteSchedulePhaseItem: build.mutation<IUpdatePhaseItemResponse, IIncompletePhaseItemBody>(
      {
        query: ({ id, ...data }) => ({
          url: `${Endpoints.SCHEDULE_PHASE_ITEMS}incomplete/${id}`,
          body: data,
          method: 'PATCH',
        }),
        invalidatesTags: ['Projects'],
      }
    ),

    deleteSchedulePhaseItem: build.mutation<undefined, IDeletePhaseItemBody>({
      query: ({ id }) => ({
        url: `${Endpoints.SCHEDULE_PHASE_ITEMS}${id}`,
        method: 'DELETE',
      }),
      invalidatesTags: (_, err, args) => (!err ? [{ type: 'Projects', id: args.projectId }] : []),
    }),
  }),
});

export const {
  useCreateSchedulePhaseItemMutation,
  useUpdateSchedulePhaseItemMutation,
  useDeleteSchedulePhaseItemMutation,
  useCompleteSchedulePhaseItemMutation,
  useIncompleteSchedulePhaseItemMutation,
} = schedulePhasesItemsApi;
